const content = {
	text: 'Save as template',
	textBody:
		'Keep these details so you don’t have to enter them all again. It’s a convenient way to make regular payments like invoices and wages – and you can make changes at any time.',
};

export default content;
